module.exports = __webpack_public_path__ + "img/icon-17-lg.32b1eef4.png";